import { createUseStyles } from 'react-jss'
import { tabletDown } from '../../../../styles/const/breakpoints'

export default createUseStyles({
  btnWrappers: {
    width: ['unset', '!important']
  },

  [`@media screen and (${tabletDown})`]: {
    btnWrappers: {
      width: ['100%', '!important']
    }
  }
})
